<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a Solution Concept</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <span class="headline font-weight-bold">Add a New Solution Concept</span> 
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-text-field outline label="Name of the solution" v-model="nameofthesolution" :rules="textInputRules"></v-text-field>
                    <v-textarea outline label="Brief Description" v-model="briefdescriptionofthesolution" :rules="textInputRules"></v-textarea>
                    <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Solution</v-btn> -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add Solution</v-btn> 
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            nameofthesolution: '',
            briefdescriptionofthesolution: '',
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            const solutionconcept = {
                nameofthesolution: this.nameofthesolution,
                briefdescriptionofthesolution: this.briefdescriptionofthesolution
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('solutionconcepts').add(solutionconcept).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          this.$emit('projectadded')
       });

    //    var dbref = db.collection('projects').doc(this.getProjectID()).collection('solutionconcepts');

    //     dbref.add(solutionconcept).then(() =>{
    //         //console.log('Collection quotes created')
    //                   this.loading = false;
    //       this.dialog = false;
    //       this.$emit('projectadded')
    //     });

             }
        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
